"use client"

import { dotsAnimation, serviceCylinderImg } from '@/assets/imgs'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { StaticImageData } from 'next/image'


type Props = {
  title: string
  header: string
  subContent: string
  content: string
  img: string | StaticImageData
}

const ServiceContent = ({ title, header, subContent, content, img }: Props) => {
  const  t  = useTranslations()

  return (
    <div className=' flex flex-col items-center justify-center gap-10 px-6 py-10 sm:py-20 sm:px-14 md:px-16 lg:my-10 lg:flex-row'>
      <div>
        <p className='font-medium uppercase'>{title}</p>
        <h3 className='my-5 text-4xl font-bold'>{header}</h3>
        <div className='relative h-1 w-24 rounded bg-orange before:absolute before:-top-1 before:h-3 before:w-3 before:animate-load before:rounded-full before:bg-orange' />
        <div className='mt-8 flex flex-col gap-10'>
          <div className='text-xl'>{subContent}</div>
          <div>{content}</div>
          <Link
            href='/contact-us'
            className='w-fit rounded-full border border-primary bg-white px-10 py-4 font-semibold text-secondary transition-all duration-200 hover:bg-linear-to-r hover:from-primary hover:from-10% hover:to-secondary hover:text-white lg:mt-0'
          >
            {t('links.contactUs')}
          </Link>
        </div>
      </div>
      <div className='relative flex justify-center lg:justify-start rtl:justify-center'>
        <Image alt='service-content-img' src={img} className='max-w-72 sm:max-w-sm lg:max-w-md' />
        <Image
        alt='cylinder'
          src={serviceCylinderImg}
          className='absolute -left-6 bottom-0 -z-10 w-40 lg:left-auto rtl:-bottom-6 rtl:-right-4'
        />
        <Image
        alt='dots'
          src={dotsAnimation}
          className='absolute top-0 -z-10 w-40 ltr:right-5 rtl:right-0'
        />
      </div>
    </div>
  )
}

export default ServiceContent
